import _toConsumableArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toArray";
import { unpack } from '../../utils/index.js';
import rgb2lab from '../lab/rgb2lab.js';
import lab2lch from './lab2lch.js';
var rgb2lch = function rgb2lch() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var _unpack = unpack(args, 'rgb'),
    _unpack2 = _toArray(_unpack),
    r = _unpack2[0],
    g = _unpack2[1],
    b = _unpack2[2],
    rest = _unpack2.slice(3);
  var _rgb2lab = rgb2lab(r, g, b),
    _rgb2lab2 = _slicedToArray(_rgb2lab, 3),
    l = _rgb2lab2[0],
    a = _rgb2lab2[1],
    b_ = _rgb2lab2[2];
  var _lab2lch = lab2lch(l, a, b_),
    _lab2lch2 = _slicedToArray(_lab2lch, 3),
    L = _lab2lch2[0],
    c = _lab2lch2[1],
    h = _lab2lch2[2];
  return [L, c, h].concat(_toConsumableArray(rest.length > 0 && rest[0] < 1 ? [rest[0]] : []));
};
export default rgb2lch;